(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('phy-announcement-bar')) {
    customElements.define('phy-announcement-bar', class extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('[data-header-main]');
        this.measure = () => {
          const height = this.parentElement.getBoundingClientRect().height;
          document.body.style.setProperty('--phy-announcement-height', height + 'px');
          document.body.style.setProperty('--announcementheight', height + 'px');
          if (this.header) {
            const headerHeight = this.header.getBoundingClientRect().height;
            document.body.style.setProperty('--phy-header-height', headerHeight + 'px');
            document.body.style.setProperty('--headerheight', headerHeight + 'px');
          }
        };
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this.parentElement);
        if (this.header) this.observer.observe(this.header);
        this.measure();
      }

      disconnectedCallback() {
        this.observer.disconnect();
        if (!document.querySelector('phy-announcement-bar')) {
          document.body.style.removeProperty('--phy-announcement-height');
          document.body.style.removeProperty('--announcementheight');
          document.body.style.removeProperty('--phy-header-height');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
